// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendor":"da5fb4a4939f4127ae64","styles":"8a980d27951379e90868"}[chunkId] + ".css";
};